module.exports = "../../../../platform/assets/pageMainIcon/simple_yewuchulilei1.svg";